<fa-icon class="{{color}}" [size]=size() ngClass="{ 'fs-1': large()}" [icon]=icon() [rotate]="rotate ? 90 : undefined"></fa-icon>